import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=006d9c62&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=ts"
export * from "./Tag.vue?vue&type=script&lang=ts"
import style0 from "./Tag.vue?vue&type=style&index=0&id=006d9c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d9c62",
  null
  
)

export default component.exports